import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { semantic_colors, text_styles } from '../../foundation';
import { Input } from '../input';

export const checker = css`
  background: linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.09) 25%,
      transparent 25%,
      transparent 75%,
      rgba(0, 0, 0, 0.09) 75%,
      rgba(0, 0, 0, 0.09) 0
    ),
    linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.09) 25%,
      transparent 25%,
      transparent 75%,
      rgba(0, 0, 0, 0.09) 75%,
      rgba(0, 0, 0, 0.09) 0
    ),
    white;
  background-repeat: repeat, repeat;
  background-position: 0 0, 5px 5px;
  background-size: 10px 10px, 10px 10px;
`;

export const NoArrowNumberInput = styled(Input)`
  input {
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;
NoArrowNumberInput.defaultProps = {
  size: 'xsmall',
  type: 'number',
};

export const Unit = styled.span`
  color: ${semantic_colors.content.secondary};
  ${text_styles.Caption_10_Medium}
`;

export const InputContainer = styled.div`
  display: grid;
  column-gap: 4px;
  grid-template-columns: 1fr 1fr 1fr;
`;
